export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 250];
export const SHOW_ALL_PAGE_SIZE = -1;
export const SENTRY_ORG_SLUG = "encamp-98d563ed0";
export const HISTORY_COLUMN_TOOLTIP =
  "Residual of this call's input after estimated system prompt and tool-definition overhead (chars/4).";

export const DONUT_COLORS = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#7f7f7f",
];

export function buildSentryTraceUrl(traceId: string): string {
  return `https://${SENTRY_ORG_SLUG}.sentry.io/explore/traces/trace/${traceId}`;
}

export function compactionKindFromJson(json: unknown): string | undefined {
  if (json === null || typeof json !== "object" || Array.isArray(json)) {
    return undefined;
  }
  if (!("kind" in json)) {
    return undefined;
  }
  const kind = json.kind;
  return typeof kind === "string" ? kind : undefined;
}

export function prettyJson(raw: string): string {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

export function prettyPartType(type: string): string {
  switch (type) {
    case "text":
      return "Text";
    case "reasoning":
      return "Reasoning";
    case "tool":
      return "Tool";
    case "source_url":
      return "Source · URL";
    case "source_document":
      return "Source · Document";
    case "file":
      return "File";
    case "step_start":
      return "Step start";
    case "abort":
      return "Abort";
    default:
      return type;
  }
}

export function prettyExtractionStatus(status: string): string {
  switch (status) {
    case "NOT_ATTEMPTED":
      return "Not attempted";
    case "PREVIEW_RUNNING":
      return "Preview running";
    case "AWAITING_CONFIRMATION":
      return "Awaiting confirmation";
    case "FULL_ANALYSIS_DECLINED":
      return "Declined";
    case "PENDING":
      return "Pending";
    case "RUNNING":
      return "Running";
    case "SUCCEEDED":
      return "Succeeded";
    case "FAILED":
      return "Failed";
    default:
      return status;
  }
}

function asFiniteNumber(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  return null;
}

export function formatCostUsd(cost: unknown): string {
  const amount = asFiniteNumber(cost);
  if (amount == null || amount <= 0) {
    return "—";
  }
  return `$${amount.toFixed(4)}`;
}

export function formatTokens(tokens: unknown): string {
  const count = asFiniteNumber(tokens);
  if (count == null || count <= 0) {
    return "—";
  }
  if (count >= 1_000_000) {
    return `${(count / 1_000_000).toFixed(1)}M`;
  }
  if (count >= 1_000) {
    return `${Math.round(count / 100) / 10}K`;
  }
  return count.toString();
}

export function formatGridCount(value: unknown): string {
  const count = asFiniteNumber(value);
  if (count == null || count <= 0) {
    return "—";
  }
  return count.toLocaleString();
}
